import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
    UncontrolledTooltip,
} from "reactstrap";

import Breadcrumbs from 'components/Common/BreadcrumbTitle';
import { getEntity } from "../../http/fundLync/entityAndAddress.helper";
import TableContainerV1 from "components/Common/TableContainerV1";
import { decryptedValue } from "common/utility";

const TableActionsComponent = (props, entityType) => {
    const navigate = useNavigate();

    const navigateToEditRoles = (id) => {
        const encryptedId = btoa(id.toString());
        const user = decryptedValue(localStorage.getItem("user"));
        navigate(`/${user.roleName}/editPartner?id=${encodeURIComponent(encryptedId)}`);
    };

    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                    onClick={() => {
                        navigateToEditRoles(props.id);
                    }}
                >
                    <i
                        className="mdi mdi-pencil font-size-16 text-success me-1"
                        id="edittooltip"
                    ></i>
                    Edit
                    <UncontrolledTooltip placement="top" target="edittooltip">
                        Edit
                    </UncontrolledTooltip>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}



const PartnerList = (props) => {
    document.title = "Partner List | Fundlync";

    const navigate = useNavigate();
    const [partnerList, setPartnerList] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
    });
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const userData = decryptedValue(localStorage.getItem("user")) || {};
    const userObj = userData;
    const { entityType } = userObj || ''
    const [sortingOptions, setSortingOptions] = useState({
        column: "id",
        isAsc: false,
        optionalColumn: ["Action"],
    });

    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "Partner Name",
                accessor: "entityName",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "Partner Type",
                accessor: "entityType",
                filterable: true,
                Cell: (cellProps) => {
                    return `${cellProps.value || ''}`;
                },
            },
            {
                Header: "Constitution",
                accessor: "entityConstitution",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "GSTN",
                accessor: "gstnIn",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "PAN",
                accessor: "pan",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';;
                },
            },
            {
                Header: "Action",
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionsComponent(rowData, entityType);
                },
            },
        ],
        []
    );

    const getPartners = data => {
        getEntity(data)
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    setPartnerList(responseFromAPI.data.data)
                    const { totalItems, totalPages, currentPage } = responseFromAPI.data
                    setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                    })
                } else {
                    setPartnerList([])
                }
            })
            .catch(error => { })
    }

    const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
        setPageSize(pageSize);
        getPartners({ page, limit: pageSize, searchKey, columnName, sortingOrder, filterType: 'Partner' })
    }

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
    };

    const handleSearchFilter = (value, pageSize) => {
        setSearchValue(value);
        handlePageChange(1, pageSize, value);
    };
    const handleClearSearch = () => {
        setSearchValue("");
        handlePageChange(1, pageSize, "");
    };

    useEffect(() => {
        getPartners({ filterType: "Partner" });
    }, []);

    const handleCustomerClicks = () => {
        const user = decryptedValue(localStorage.getItem("user"));
        navigate(`/${user.roleName}/addPartner`)
    };

    const buttonSection = (
        <div className="text-sm-end">
            <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClicks}
            >
                <i className="mdi mdi-plus me-1" />
                {'Add Partner'}
            </Button>
        </div>
    );

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Partner List" />
                <Row className="vertical-scroll">
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <TableContainerV1
                                    columns={columns}
                                    data={partnerList}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    handleSearchFilter={handleSearchFilter}
                                    customSection={buttonSection}
                                    sortOptions={sortingOptions}
                                    handleSortColumn={handleSortColumn}
                                    handleClearSearch={handleClearSearch}
                                    className="custom-header-css"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PartnerList;
